import PropTypes from 'prop-types';

export default PropTypes.shape({
  data: PropTypes.any,
  key: PropTypes.any,
  isPending: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  render: PropTypes.func
});